import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Link as RouterLink, useNavigate, useParams, useLocation } from 'react-router-dom';
import { useAdminTeamQuery } from '../../api/admin';
import { AppCard, AppCardTitle, AppPageHeader } from '../../components';
import { TeamMembersTable } from '../../components/Admin';

export default function TeamDetailPage() {
	const { team_id } = useParams<{ team_id: string }>();
	const navigate = useNavigate();
	const location = useLocation();
	const teamId = parseInt(team_id!, 10);

	const { teamName: stateTeamName, organizationName: stateOrganizationName } =
		(location.state as { teamName?: string; organizationName?: string }) ?? {};
	const { data: team } = useAdminTeamQuery(teamId);

	const teamName = team?.name ?? stateTeamName ?? `Team #${teamId}`;
	const organizationName = team?.organization_name ?? stateOrganizationName;

	return (
		<>
			<AppPageHeader>
				<Stack direction="row" alignItems="center" spacing={2} mb={1}>
					<Button size="small" startIcon={<ArrowBackIcon />} onClick={() => navigate('/admin/users?tab=teams')}>
						All Teams
					</Button>
				</Stack>
				<Typography variant="h5">{teamName}</Typography>
				{organizationName && (
					<Typography variant="body2" color="text.secondary">
						Organization:{' '}
						{team ? (
							<Link component={RouterLink} to={`/admin/organizations/${team.organization_id}`}>
								{organizationName}
							</Link>
						) : (
							organizationName
						)}
					</Typography>
				)}
				{team?.description && (
					<Typography variant="body2" color="text.secondary">
						{team.description}
					</Typography>
				)}
			</AppPageHeader>
			<AppCard>
				<AppCardTitle variant="h6">Members</AppCardTitle>
				<TeamMembersTable teamId={teamId} teamName={teamName} />
			</AppCard>
		</>
	);
}
